import React from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import ExpandablePanel from '../../components/controls/ExpandablePanel'

export default function WewnetrzneJednostki({
  title,
  label,
  data,
  onSetSectionData,
}) {
  return (
    <ExpandablePanel title={title}>
      <form autoComplete="off">
        <FormControlLabel
          className="checkboxLabel high-caption"
          control={
            <Checkbox
              name="LaczneSprawozdanie"
              color="primary"
              defaultChecked={data.LaczneSprawozdanie}
              onChange={e =>
                onSetSectionData('LaczneSprawozdanie', e.target.checked)
              }
            />
          }
          label={label}
        />
      </form>
    </ExpandablePanel>
  )
}
